// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Zel6T","content":"styles_content__5SnFT","row":"styles_row__1DnXw","footer":"styles_footer__38RM1","phraseLength":"styles_phraseLength__1nDvX"};